import { createAction } from '@reduxjs/toolkit'

export const defaultAction = createAction<string>('ACTION/DEFAULT')
